import { CmsComponentTypeEnum } from '@models/enums/cms-component-type.enum';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';

export namespace Divider {
  export const TypeEnum = CmsComponentTypeEnum.DIVIDER;

  export interface ComponentConfig extends BaseComponentConfig {
    styled?: boolean;
  }
}
